module.exports = __webpack_public_path__ + "img/solution_td.46bda0de.png";